import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const ShareWithUserIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    height: getDefaultHeight(svgProps, 25),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "1.5",
    children: [/*#__PURE__*/jsx("path", {
      d: "M20.017 14.337a.448.448 0 0 0-.473-.05.452.452 0 0 0-.183.162.416.416 0 0 0-.067.228v1.15c-7.055.286-7.135 7.442-7.135 7.511a.414.414 0 0 0 .115.292c.077.08.182.131.296.142a.466.466 0 0 0 .289-.107.418.418 0 0 0 .147-.257s.758-4.142 6.244-4.332V20.6c0 .083.026.164.073.234.048.07.115.126.195.162a.47.47 0 0 0 .481-.078l3.567-3.151a.42.42 0 0 0 0-.659l-3.549-2.772Z"
    }), /*#__PURE__*/jsx("circle", {
      cx: "9.5",
      cy: "6.5",
      r: "4.5"
    }), /*#__PURE__*/jsx("path", {
      strokeLinecap: "round",
      d: "M14.5 14.5s-1.5-2-5-2c-6 0-8 7-8 7"
    })]
  });
};

export { ShareWithUserIcon };
//# sourceMappingURL=user.share.js.map
